export default __webpack_public_path__ + "static/media/404-page-dark.f24684e7.png";